export default __webpack_public_path__ + "static/media/eye.45464371.svg";